import * as React from "react"
const DocumentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 9.333a.667.667 0 0 1-.667.667H4a.667.667 0 1 1 0-1.333h5.333a.667.667 0 0 1 .667.666Zm-2.667 2H4a.667.667 0 0 0 0 1.334h3.333a.667.667 0 0 0 0-1.334Zm6-4.343v5.677A3.337 3.337 0 0 1 10 16H3.333A3.337 3.337 0 0 1 0 12.667V3.333A3.337 3.337 0 0 1 3.333 0h3.01a4.639 4.639 0 0 1 3.3 1.367l2.323 2.324a4.634 4.634 0 0 1 1.367 3.299ZM8.701 2.31A3.34 3.34 0 0 0 8 1.79v2.877a.667.667 0 0 0 .667.666h2.877a3.32 3.32 0 0 0-.52-.7L8.7 2.31ZM12 6.99c0-.11-.021-.215-.031-.323H8.667a2 2 0 0 1-2-2V1.365c-.108-.01-.214-.032-.324-.032h-3.01a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2H10a2 2 0 0 0 2-2V6.99Z"
    />
  </svg>
)
export default DocumentIcon
